import { render, staticRenderFns } from "./ResourceOther.vue?vue&type=template&id=426016c2"
import script from "./ResourceOther.vue?vue&type=script&lang=js"
export * from "./ResourceOther.vue?vue&type=script&lang=js"
import style0 from "./ResourceOther.vue?vue&type=style&index=0&id=426016c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports